// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import dayjs from 'dayjs';
import type { UserProfileData } from '../components/user-profile/use-user-profile';

const DISPLAY_PLACEHOLDER = '-';

/** Profile fields shared by retail and advisor client profile APIs. */
export type ClientProfileDisplaySource = {
  email: string;
  name?: string | null;
  first_name?: string | null;
  second_name?: string | null;
  first_surname?: string | null;
  second_surname?: string | null;
  nif_nie?: string | null;
  document_number?: string | null;
  phone_number?: string | null;
  address?: string | null;
  street_name?: string | null;
  postal_code?: string | null;
  city?: string | null;
  country?: string | null;
  birth_date?: string | null;
};

const formatBirthDate = (birthDate?: string | null): string => {
  if (!birthDate) return DISPLAY_PLACEHOLDER;

  const parsed = dayjs(birthDate);

  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : birthDate;
};

export const mapClientProfileToDisplay = (
  profileData: ClientProfileDisplaySource,
  options?: { nameFallback?: string },
): UserProfileData => ({
  name: profileData.name ?? options?.nameFallback ?? '',
  first_name: profileData.first_name ?? options?.nameFallback ?? '',
  second_name: profileData.second_name ?? null,
  first_surname: profileData.first_surname ?? null,
  second_surname: profileData.second_surname ?? null,
  email: profileData.email,
  document_number:
    profileData.document_number ?? profileData.nif_nie ?? DISPLAY_PLACEHOLDER,
  phone_number: profileData.phone_number ?? DISPLAY_PLACEHOLDER,
  address: profileData.address ?? profileData.street_name ?? null,
  postal_code: profileData.postal_code ?? null,
  city: profileData.city ?? null,
  country: profileData.country ?? DISPLAY_PLACEHOLDER,
  birth_date: formatBirthDate(profileData.birth_date),
});
